import { reactive } from 'vue'

// export const info = reactive({
//   moneybox: '',
// })

export const notification = reactive({
  // message: 'HOOFER EDITION (Search by date. For example: "2020-01-01T10:40:00")',
  message: '',
  type: '',
})

export const blockInfo = reactive({
  moneybox: null,
})
